import { createSelector } from 'reselect';

// Global Selectors
import { selectOrganizationsOrderedByName } from 'services/organizations/selectors';

// Types
import { Organization } from 'services/organizations/types';

const selectIds = createSelector(
    selectOrganizationsOrderedByName,
    (orderedDataState) =>
        orderedDataState &&
        orderedDataState.map((value: Organization) => value.id)
);

const selectActiveIds = createSelector(
    selectOrganizationsOrderedByName,
    (orderedDataState) =>
        orderedDataState &&
        orderedDataState
            .filter((value: Organization) => !value.deletedAt)
            .map((value: Organization) => value.id)
);

export { selectIds, selectActiveIds };
